<template>
    <div>

      <season-widget></season-widget>

        <div class="row">

            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-3" style="margin-bottom: 20px">
                        <router-link :to="{path:'/admin/jugadores'}">
                            <div class="panel">
                                <div class="row">
                                    <div class="col-md-12" style="padding-right: 0">
                                        <img src="img/logo.png" class="imgPanel img-fluid">
                                    </div>
                                </div>
                                <p class="text-center txtPanel noselect">Jugadores</p>
                            </div>
                        </router-link>

                    </div>

                    <div class="col-md-3" style="margin-bottom: 20px">
                        <router-link :to="{path:'/admin/grupos'}">
                            <div class="panel">
                                <div class="row">
                                    <div class="col-md-12" style="padding-right: 0">
                                        <img src="img/logo.png" class="imgPanel img-fluid">
                                    </div>
                                </div>
                                <p class="text-center txtPanel noselect">Grupos</p>
                            </div>
                        </router-link>
                    </div>

                    <div class="col-md-3" style="margin-bottom: 20px">
                        <router-link :to="{path:'/admin/presupuestos'}">
                            <div class="panel">
                                <div class="row">
                                    <div class="col-md-12" style="padding-right: 0">
                                        <img src="img/logo.png" class="imgPanel img-fluid">
                                    </div>
                                </div>
                                <p class="text-center txtPanel noselect">Presupuestos</p>
                            </div>
                        </router-link>
                    </div>

                    <div class="col-md-3" style="margin-bottom: 20px">
                        <router-link :to="{path:'/admin/pagos/1/1/1'}">
                            <div class="panel">
                                <div class="row">
                                    <div class="col-md-12" style="padding-right: 0">
                                        <img src="img/logo.png" class="imgPanel img-fluid">
                                    </div>
                                </div>
                                <p class="text-center txtPanel noselect">Pagos de jugadores</p>
                            </div>
                        </router-link>
                    </div>

<!--                  <div class="col-md-3" style="margin-bottom: 20px">-->
<!--                    <router-link :to="{path:'/admin/servicios'}">-->
<!--                      <div class="panel">-->
<!--                        <div class="row">-->
<!--                          <div class="col-md-12" style="padding-right: 0">-->
<!--                            <img src="img/logo.png" class="imgPanel img-fluid">-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <p class="text-center txtPanel noselect">Servicios</p>-->
<!--                      </div>-->
<!--                    </router-link>-->
<!--                  </div>-->

<!--                    <div class="col-md-3" style="margin-bottom: 20px">-->
<!--                        <router-link :to="{path:'/admin/entrenadores'}">-->
<!--                            <div class="panel">-->
<!--                                <div class="row">-->
<!--                                    <div class="col-md-12" style="padding-right: 0">-->
<!--                                        <img src="img/logo.png" class="imgPanel img-fluid">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <p class="text-center txtPanel noselect">Entrenadores</p>-->
<!--                            </div>-->
<!--                        </router-link>-->
<!--                    </div>-->

<!--                    <div class="col-md-3" style="margin-bottom: 20px">-->
<!--                        <router-link :to="{path:'/admin/balones'}">-->
<!--                            <div class="panel">-->
<!--                                <div class="row">-->
<!--                                    <div class="col-md-12" style="padding-right: 0">-->
<!--                                        <img src="img/logo.png" class="imgPanel img-fluid">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <p class="text-center txtPanel noselect">Balones</p>-->
<!--                            </div>-->
<!--                        </router-link>-->
<!--                    </div>-->

                    <div class="col-md-3" style="margin-bottom: 20px">
                        <router-link :to="{path:'/admin/correos'}">
                            <div class="panel">
                                <div class="row">
                                    <div class="col-md-12" style="padding-right: 0">
                                        <img src="img/logo.png" class="imgPanel img-fluid">
                                    </div>
                                </div>
                                <p class="text-center txtPanel noselect">Enviar correos</p>
                            </div>
                        </router-link>
                    </div>
                </div>

            </div>

            <!--<div class="col-md-4">-->
                <!--<div class="row">-->
                    <!--<div class="col-md-12">-->
                        <!--<div class="card border-primary ">-->
                            <!--<div class="card-header bg-light">-->
                                <!--<strong>Ultimas inscripciones</strong>-->
                            <!--</div>-->
                            <!--<div class="card-body">-->
                                <!--<p class="card-text">With supporting text below as a natural lead-in to additional content.</p>-->
                                <!--<p class="card-text">With supporting text below as a natural lead-in to additional content.</p>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->


        </div>
    </div>
</template>
<script>

import SeasonWidget from "@/views/Dashboard/Widgets/SeasonWidget";

    export default {
        components: {
          SeasonWidget
        },
        data() {
            return {
                players: []
            };
        },
        methods: {}

    };
</script>
<style scoped>

    .panel {
        cursor: pointer;
        text-align: center;
        padding: 15px;
        border-radius: 5px;
        border: 1px solid #cdcdcd;
        background-color: #f1f1f1;
        transition: background-color 0.2s;
    }

    .panel:hover {
        background-color: #36305c;
    }

    .panel:hover p {
        color: #eee;
        text-shadow: 2px 2px 2px #000;
    }

    .txtPanel {
        font-size: 1.6em;
        margin-top: 30px;
        color: #111;
        text-shadow: 2px 2px 2px #eee;
    }

    .imgPanel {
        margin-top: 20px;
        padding: 12px;
        background-color: #fff;
        border-radius: 5%;
        max-width: 150px;
    }

    @media (max-width: 600px) {
        .imgPanel {
            max-width: 100px;
        }
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }

</style>
